import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DIALOG_DATA, getInstanceRegion } from '../../../../../global.variable';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { DialogRef } from '../../../../shared/components/modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { JobsService } from '../../jobs/jobs.service';
import { SubContactorsService } from '../sub-contactors.service';

@Component({
  selector: 'gtapp-add-edit-sub-contractor',
  standalone: false,
  templateUrl: './add-edit-sub-contractor.html',
  styleUrl: './add-edit-sub-contractor.scss',
})
export class AddEditSubContractor implements OnInit {
  @Input() subContractorId: string = '';
  @Output() eventUpdated = new EventEmitter();

  subContractorDetailData: any = {};
  contractorForm: UntypedFormGroup = new UntypedFormGroup({
    company_name: new UntypedFormControl('', [Validators.required]),
    mobile_number: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
  });
  addressForm: UntypedFormGroup = new UntypedFormGroup({
    address1: new UntypedFormControl(''),
    address2: new UntypedFormControl('', [Validators.required]),
    address3: new UntypedFormControl(''),
    city_name: new UntypedFormControl('', [Validators.required]),
    postcode: new UntypedFormControl(''),
    longitude: new UntypedFormControl('', [Validators.required]),
    latitude: new UntypedFormControl('', [Validators.required]),
    country_name: new UntypedFormControl(getInstanceRegion(), [
      Validators.required,
    ]),
    state_code: new UntypedFormControl('', [Validators.required]),
    state_name: new UntypedFormControl('', [Validators.required]),
  });

  isAdmin = this.dataCheckService.isUserAdmin();
  currentStep: number = 1;

  userListData: any = [];
  userLookupDataList: any = [];
  userListNextCursor: string = '';
  userSearchString: string = '';
  isLoadingMoreUsers: boolean = false;
  selectedUserIds: Set<number> = new Set();

  routedHere: boolean = false;

  constructor(
    private contractorService: SubContactorsService,
    private spinnerService: LoadingSpinnerService,
    private dataCheckService: DataCheckService,
    @Optional()
    protected dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
    private router: Router,
  ) {}
  ngOnInit(): void {
    let subscontractorId: any = this.route.snapshot.paramMap.get('sKey');

    if (subscontractorId) {
      subscontractorId = atob(subscontractorId);
      this.routedHere = true;
    }

    this.subContractorId = this.subContractorId || subscontractorId;
    if (this.subContractorId) {
      this.getContractorDetails();
    }
  }
  getContractorDetails() {
    this.spinnerService.show();
    this.contractorService
      .getContactorDetailById(btoa(this.subContractorId))
      .then((response: any) => {
        if (response?.status == 'success') {
          this.spinnerService.hide();
          this.formatSelectedSubContractor(response?.data);
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }
      });
  }
  formatSelectedSubContractor(responseData: any) {
    this.subContractorDetailData = responseData;
    this.contractorForm.patchValue(this.subContractorDetailData);
    this.addressForm.patchValue(this.subContractorDetailData?.address);

    this.subContractorDetailData?.users?.forEach((userData: any) => {
      if (!this.selectedUserIds.has(userData?.id)) {
        this.selectedUserIds.add(userData?.id);
      }
    });
  }

  openTemplate(template: TemplateRef<any>, field: string) {
    if (field === 'users') {
      this.userListNextCursor = '';
      this.userListData = [];
      this.subContractorDetailData?.users?.forEach((userData: any) => {
        this.userListData.push(userData);
      });
      this.loadUserList();
    }
    this.dialogService.open(
      template,
      { data: { field: field } },
      this.viewContainerRef,
    );
  }
  onCloseDialogue(value?: any) {
    this.dialogRef.close(value);
  }
  onCreateSubContractor() {
    let requestData = {
      ...this.contractorForm.value,
      ...this.addressForm.value,
      user_ids: [...this.selectedUserIds],
    };
    requestData.mobile_number = requestData?.mobile_number || 0;
    this.contractorService.addContractor(requestData).then((response: any) => {
      if (response?.status == 'success') {
        this.onCloseDialogue(response?.data);
      } else {
        this.toasterService.setMessage({
          errorMessage: response['message'],
          successMessage: '',
        });
      }
    });
  }
  mobileNumberCheck() {
    if (!this.contractorForm.value?.mobile_number) {
      this.contractorForm.controls['mobile_number'].setValue(null);
      this.contractorForm.controls['mobile_number'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.contractorForm.controls['mobile_number'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }
  deleteContractor() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.spinnerService.show('Removing');
        this.contractorService
          .updateContractor(
            btoa(this.subContractorId),
            {},
            { delete_contractor: 1 },
          )
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              this.eventUpdated.emit({});
              if (this.routedHere) {
                this.router.navigate(['/sub-contractors']);
              }
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                errorMessage: response['message'],
                successMessage: '',
              });
            }
          });
      }
    });
  }
  updateContractor(field: string) {
    let requestData: any = {};
    let params: any = { [`update_${field}`]: 1 };
    switch (field) {
      case 'company_name':
        requestData[field] = this.contractorForm.value[field];
        break;
      case 'email':
        requestData[field] = this.contractorForm.value[field];
        break;
      case 'mobile_number':
        requestData[field] = this.contractorForm.value[field] || 0;
        break;
      case 'full_address':
        requestData['address'] = this.addressForm.value;
        break;
      case 'users':
        requestData['user_ids'] = [...this.selectedUserIds];
        break;
    }
    this.spinnerService.show();

    this.contractorService
      .updateContractor(btoa(this.subContractorId), requestData, params)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.eventUpdated.emit(response?.data);
          this.formatSelectedSubContractor(response?.data);
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }
      });
  }
  addSelectedUser(userData: any) {
    setTimeout(() => {
      this.userSearchString = '';
    }, 50);

    this.selectedUserIds.add(userData?.id);

    // If the user is not already in loadedUsers, prepend for visibility
    if (!this.userListData?.some((lu: any) => lu?.id === userData?.id)) {
      this.userListData.unshift(userData);
    }
    this.moveSelectedUsersToTop();
  }
  selectAll() {
    if (this.selectedUserIds?.size === this.userListData?.length) {
      this.selectedUserIds.clear();
    } else {
      this.selectedUserIds.clear();
      this.userListData?.forEach((userData: any) => {
        this.selectedUserIds.add(userData?.id);
      });
    }
  }
  addRemoveUser(userData: any) {
    if (this.selectedUserIds.has(userData?.id)) {
      this.selectedUserIds.delete(userData?.id);
    } else {
      this.selectedUserIds.add(userData?.id);
    }
    this.moveSelectedUsersToTop();
  }
  moveSelectedUsersToTop() {
    this.userListData?.sort((a: any, b: any) => {
      if (
        this.selectedUserIds?.has(a?.id) === this.selectedUserIds?.has(b?.id)
      ) {
        return 0;
      }
      return this.selectedUserIds?.has(a?.id) ? -1 : 1;
    });
  }

  searchUsers(event?: any) {
    const searchStr = event?.target?.value || '';
    this.userSearchString = searchStr;
    if (searchStr?.length < 2) return;

    this.jobService
      .getUserList({
        search_str: this.userSearchString,
        sub_contractors_list: 1,
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.userLookupDataList = response.data.filter(
            (u: any) => !this.userListData?.some((lu: any) => lu?.id === u?.id),
          );
        }
      });
  }
  loadUserList() {
    if (this.isLoadingMoreUsers) return;

    this.isLoadingMoreUsers = true;
    let params: any = { rows: 15, sub_contractors_list: 1 };

    if (this.userListNextCursor) {
      params['next_cursor'] = this.userListNextCursor;
    }
    if (this.userSearchString) params.search_str = this.userSearchString;

    this.jobService.getUserList(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.userListNextCursor = response?.next_cursor;

        const newUsers = response.data.filter(
          (u: any) => !this.userListData?.some((lu: any) => lu?.id === u?.id),
        );

        this.userListData.push(...newUsers);
        this.isLoadingMoreUsers = false;
      } else {
        this.isLoadingMoreUsers = false;
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response?.message,
        });
      }
    });
  }
}
